export default function CircularProgress({dashboardCard1Object, percent, label }) {
  return (
    <div className="stat-card" style={{background:`${dashboardCard1Object?.statCircleCard?.bgColor?.color}` , border:` ${dashboardCard1Object?.statCircleCard?.border?.borderWidth?.value+dashboardCard1Object?.statCircleCard?.border?.borderWidth?.resolution} ${dashboardCard1Object?.statCircleCard?.border?.borderType}  ${dashboardCard1Object?.statCircleCard?.border?.borderColor?.color}`,
     borderTopLeftRadius:`${dashboardCard1Object?.statCircleCard?.borderRadius?.topLeft?.value}${dashboardCard1Object?.statCircleCard?.borderRadius?.topLeft?.resolution}`,
                  borderTopRightRadius:`${dashboardCard1Object?.statCircleCard?.borderRadius?.topRight?.value}${dashboardCard1Object?.statCircleCard?.borderRadius?.topRight?.resolution}`,
                  borderBottomLeftRadius:`${dashboardCard1Object?.statCircleCard?.borderRadius?.bottomLeft?.value}${dashboardCard1Object?.statCircleCard?.borderRadius?.bottomLeft?.resolution}`,
                  borderBottomRightRadius:`${dashboardCard1Object?.statCircleCard?.borderRadius?.bottomRight?.value}${dashboardCard1Object?.statCircleCard?.borderRadius?.bottomRight?.resolution}`,margin:"5px",padding:"10px 15px",color:`${dashboardCard1Object?.statCircleCard?.textColor?.color}`}}>
      <div className="circleDashB" >
        <strong className="dashboardPageTagsFont">{percent}%</strong>
      </div>
      <p className="dashboardPageTitleFont">{label}</p>
      <small className="dashboardPageSubTitleFont">Next Badge: Not defined</small>
  
  <style>{`.circleDashB {
  width: 110px;
  height: 110px;
  border-radius: 50%;
  border: 8px dashed ${dashboardCard1Object?.statCircleCard?.iconColor?.color};
  display: grid;
  place-items: center;
  margin: auto;
}`}</style>  </div>
  );
}
